module.exports = __webpack_public_path__ + "static/img/100826.85beb78b.png";